<template>
  <div>
    <div v-if="loading" class="text-xs-center my-5 pt-5">
      <v-progress-circular :size="50" color="black" indeterminate/>
    </div>

    <div v-else>
      <v-layout row>
        <v-flex>
          <h1>{{ $tc('COMMON.PURCHASE', 2) }}</h1>
        </v-flex>
      </v-layout>

      <masonry :cols="{default: 3, 1200: 2, 960: 1}" :gutter="40">
        <tk-artwork v-for="artwork in artworks" :key="artwork.id" class="mb-4" :artwork="artwork"/>
      </masonry>

      <div class="text-xs-right mt-4" v-if="artworks.length">
        <v-pagination
          @input="fetchData"
          :disabled="loading"
          :value="pagination.currentPage"
          :length="pagination.lastPage"
          :total-visible="7"
        />
      </div>

      <div class="text-xs-center mt-5">
        <router-link to="/cancellation">{{ $t('MENU.CANCELLATION_NOTICE') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/services/RepositoryFactory";
import { ErrorHandler } from "@/utils/ErrorHandler";

const artworksRepo = RepositoryFactory.artworks();
const handler = new ErrorHandler();

export default {
  data() {
    return {
      showSortDialog: false,
      artworks: [],
      pagination: {},
      loading: true
    };
  },

  created() {
    this.fetchData(1);
  },

  methods: {
    async fetchData(page) {
      this.loading = true;
      await handler.handle(async () => {
        const res = await artworksRepo.profilePurchasedArtworks(page);
        this.artworks = res.data;
        this.pagination = res.pagination;
      });
      this.loading = false;
    }
  }
};
</script>
